import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet, { blue, lightBlue } from 'src/constants/stylesheet';
import { useApi } from 'src/@context/Api';
import { Language } from 'src/utils/Languages';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import fonts from 'src/constants/fonts';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            backgroundColor: 'white',
        },
        menu: {
            padding: 20,
        },
        menuItem: {
            marginBottom: '0.7rem',

            '&:last-child': {
                marginBottom: 0,
            },
        },
        menuItemSubmenu: {
            position: 'relative',
            paddingRight: 20,
        },
        submenuArrow: {
            position: 'absolute',
            top: 0,
            right: 0,
            width: 10,
            transform: 'rotate(0)',
            transition: 'trasfron .4s ease',

            '$submenuOpen &': {
                transform: 'rotate(-90deg)',
            }
        },
        submenuOpen: {},
        menuLink: {
            ...stylesheet.TitleH3,
            width: '100%',
            display: 'block',
            textAlign: 'left',
            textTransform: 'uppercase',
        },
        menuLinkButton: {
            backgroundColor: 'transparent',
            // border: 0,
            '&:focus': {
                outline: 'none'
            }
        },
        menuLinkActive: {
            color: 'white',
            backgroundColor: blue
        },
        submenuContainer: {
            height: 0,
            overflow: 'hidden',
            transition: 'height .4s ease',

            '$submenuOpen &': {
                height: 'auto'
            }
        },
        fill: {
            fill: blue,
        },
        submenuNav: {
            padding: '1rem 1.5rem',
        },
        submenuItem: {
            marginBottom: '0.5rem',

            '&:last-child': {
                marginBottom: 0,
            }
        },
        submenuLink: {
            ...stylesheet.TitleH3,
            width: '100%',
            display: 'block',
            textAlign: 'left',
            textTransform: 'uppercase',
            fontSize: '1rem',
        },
        langNav: {
            display:'flex',
            padding: '0 20px'
        },
        langLink: {
          marginRight: 10,
          color: lightBlue,
    
          ...fonts.Condensed,
        },
        langActive:{
          color: blue
        }
    }));

export type MenuMobileProps = {
    onMenuClick: () => void;
};
type Props = MenuMobileProps;

const MenuMobile: FC<Props> = ({ onMenuClick }) => {
    const cls = useStyles();
    const { app } = useApi();
    const [submenu, setSubmenu] = useState<PagesDto>();

    const arrowSVG =
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 17.8 35.5"
            enableBackground="new 0 0 17.8 35.5;"
        >
            <polygon className={cls.fill} points="17.8,0 0,17.8 17.8,35.5 " />
        </svg>;

    const handleSubmenuToggle = (page: PagesDto) => {

        if (submenu && submenu.UID === page.UID) {
            setSubmenu(undefined);
            return;
        }

        setSubmenu(page);
    }

    return (
        <nav className={cls.root}>
            <ul className={cls.menu}>

                {app && app.Menus.map(menu => {
                    switch (menu.type) {
                        case "Pages":
                            const s = menu as PagesDto;
                            return (
                                <li
                                    className={
                                        classNames(
                                            cls.menuItem,
                                            cls.menuItemSubmenu,
                                            submenu && submenu.UID === s.UID && cls.submenuOpen)
                                    }
                                    key={`menu-${s.UID}`}
                                >
                                    <button
                                        className={classNames(cls.menuLink, cls.menuLinkButton)}
                                        // tslint:disable-next-line:jsx-no-lambda
                                        onClick={() => handleSubmenuToggle(s)}
                                    >
                                        {menu.Title}
                                    </button>
                                    <div className={cls.submenuArrow}>
                                        {arrowSVG}
                                    </div>

                                    <nav className={cls.submenuContainer}>
                                        <ul className={cls.submenuNav}>
                                            {s.Children.map(c =>
                                                <li
                                                    key={`menu-${c.UID}`}
                                                    className={cls.submenuItem}
                                                >
                                                    <NavLink
                                                        to={`/${Language}/${s.UID}/${c.UID}`}
                                                        className={cls.submenuLink}
                                                        onClick={onMenuClick}
                                                    >
                                                        {c.Title}
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </nav>

                                </li>
                            );
                        default:
                            return (
                                <li
                                    key={`menu-${menu.UID}`}
                                    className={cls.menuItem}
                                >
                                    <NavLink
                                        to={`/${Language}/${menu.UID}`}
                                        onClick={onMenuClick}
                                        className={cls.menuLink}
                                    >
                                        {menu.Title}
                                    </NavLink>
                                </li>
                            );
                    }
                })}
            </ul>
            <ul className={cls.langNav}>
                <li>
                    <a 
                        href="?switch-lang=de" 
                        className={classNames(cls.langLink, Language === 'de' && cls.langActive)}
                    >
                    D
                    </a>
                </li>
                <li>
                    <a 
                        href="?switch-lang=de" 
                        className={classNames(cls.langLink, Language === 'en' && cls.langActive)}
                    >
                    E
                    </a>
                </li>
                <li>
                    <a 
                        href="?switch-lang=fr" 
                        className={classNames(cls.langLink, Language === 'fr' && cls.langActive)}
                    >
                    F
                    </a>
                </li>
                <li>
                    <a 
                        href="?switch-lang=it" 
                        className={classNames(cls.langLink, Language === 'it' && cls.langActive)}
                    >
                    I
                    </a>
                </li>
            </ul>
        </nav >
    );
}

export default MenuMobile;


// WEBPACK FOOTER //
// ./src/Components/MenuMobile.tsx